import React, {useRef, useEffect} from 'react'
import TeamCaroussel from '../../componenents/teamCaroussel';
import { useTranslation } from 'react-i18next';
import {motion} from 'framer-motion';
import { useGlobalContext } from '../../context';

function Team() {
  const {t} = useTranslation();
  const {initial, final, animation1,  setSectionRef, sectionRef} = useGlobalContext();
  
  const teamRef = useRef(null);
  
  useEffect(() => {
    setSectionRef({ ...sectionRef, team: teamRef });
  }, [setSectionRef, sectionRef, teamRef]);
  return (
    <section
    ref={teamRef}
    className="section team">
        <div className="container team__container">
            <div className="team__title">
              <motion.h2 
                initial={initial}
                whileInView={final}
                
                viewport={animation1}
              >
                {t('team')}
              </motion.h2>
            </div>
            <TeamCaroussel/>
        </div>
    </section>
  )
}

export default Team;